import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=4ce13cc8&scoped=true&lang=pug&"
import script from "./Turno.vue?vue&type=script&lang=js&"
export * from "./Turno.vue?vue&type=script&lang=js&"
import style0 from "./Turno.vue?vue&type=style&index=0&id=4ce13cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce13cc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce13cc8')) {
      api.createRecord('4ce13cc8', component.options)
    } else {
      api.reload('4ce13cc8', component.options)
    }
    module.hot.accept("./Turno.vue?vue&type=template&id=4ce13cc8&scoped=true&lang=pug&", function () {
      api.rerender('4ce13cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Turno.vue"
export default component.exports